import { OverclaimHistory } from '@Entities/overclaim/overclaim-history'
import React from 'react'
import dayjs from 'dayjs'

interface OverclaimHistoryRowProps {
    historyRow: OverclaimHistory
}

const OverclaimHistoryRow = ({ historyRow }: OverclaimHistoryRowProps) => {
    const isNotification = historyRow.eventType === 'NOTIFICATION'
    const date = historyRow.timelineDate
    let action: string
    if (isNotification) {
        action = historyRow.notificationType
    } else {
        const previousSharePercentage = historyRow.previousSharePercentage ?? 0
        const currentSharePercentage = historyRow.currentSharePercentage ?? 0
        action =
            historyRow.shareChangeType === 'ADDED'
                ? `${historyRow.topPublisherName} was added to the Overclaim with shares of ${currentSharePercentage}%`
                : `${historyRow.topPublisherName} shares updated from ${previousSharePercentage}% to ${currentSharePercentage}%`
    }
    const actor = isNotification ? historyRow.createdByMember : null
    const formattedDate = date ? dayjs(date).utc().format('MMMM DD, YYYY') : ''

    return (
        <div className="history-row-wrapper">
            <div className="history-row">
                <div className="history-cell">
                    <div>Date</div>
                    <div>{formattedDate}</div>
                </div>
                <div className="history-cell">
                    <div>Action</div>
                    <div>{action}</div>
                </div>
                {isNotification && (
                    <div className="history-cell">
                        <div>Action Completed By</div>
                        <div>{actor}</div>
                    </div>
                )}
            </div>
        </div>
    )
}
export default OverclaimHistoryRow
